(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('vendorUpdateAction', {
      controller: Controller,
      templateUrl: 'actions/vendor/update/update-vendor.action.html',
      bindings: {
        vendor: '<',
        vendorId: '<',
        then: '&',
        catch: '&'
      }
    });
}());
